import React, { useState } from "react";
import "./Newsletter.css";
import dropdownIcon from "../../assets/dropdown.svg";
import Seo from "../../seo/Seo";

const Newsletter = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    college: "",
    gradYear: "",
    roleType: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.email) {
      alert("Please enter your email.");
      return;
    }

    setIsSubmitting(true);

    // Encode form data for Google Apps Script
    const encodedData = new URLSearchParams();
    encodedData.append("firstName", formData.firstName);
    encodedData.append("lastName", formData.lastName);
    encodedData.append("email", formData.email);
    encodedData.append("college", formData.college);
    encodedData.append("gradYear", formData.gradYear);
    encodedData.append("roleType", formData.roleType);

    try {
      const response = await fetch(
        "https://script.google.com/macros/s/AKfycbzvAa0P-PHnhdX0ywl-uc83fYSOdhpa0sjy-B3AxKXPElsJFq8E8MLBl7CAKbPjpCHr8A/exec",
        {
          method: "POST",
          body: encodedData,
        }
      );

      const text = await response.text();
      if (text.includes("Success")) {
        alert("✅ Thanks for subscribing!");
        
        // Wait a tiny moment to let the alert close before clearing
        setTimeout(() => {
          setFormData({
            firstName: "",
            lastName: "",
            email: "",
            college: "",
            gradYear: "",
            roleType: "",
          });
        }, 100);
      }
       else {
        alert("⚠️ There was an issue submitting your form. Please try again.");
      }
    } catch (error) {
      console.error("Submission error:", error);
      alert("❌ There was an issue submitting your form. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="newsletter-page">
      <Seo path="/newsletter" />
      <div className="newsletter-card">
        <h1 className="newsletter-title">Join Our Newsletter!</h1>
        <p className="newsletter-subtitle">
          Get updates on{" "}
          <span className="highlight-text">
            newly posted jobs, internships, real interview questions, and more
          </span>
        </p>

        <form className="newsletter-form" onSubmit={handleSubmit}>
          {/* Row 1: First + Last Name */}
          <div className="newsletter-row">
            <div className="newsletter-col">
              <label className="newsletter-label">First Name</label>
              <input
                className="newsletter-input"
                type="text"
                name="firstName"
                placeholder="First name"
                value={formData.firstName}
                onChange={handleChange}
                required
              />
            </div>
            <div className="newsletter-col">
              <label className="newsletter-label">Last Name</label>
              <input
                className="newsletter-input"
                type="text"
                name="lastName"
                placeholder="Last name"
                value={formData.lastName}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          {/* Row 2: Email + College */}
          <div className="newsletter-row">
            <div className="newsletter-col">
              <label className="newsletter-label">Email</label>
              <input
                className="newsletter-input"
                type="email"
                name="email"
                placeholder="Email address"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="newsletter-col">
              <label className="newsletter-label">College</label>
              <input
                className="newsletter-input"
                type="text"
                name="college"
                placeholder="College name"
                value={formData.college}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          {/* Row 3: Graduation Year + Role Type */}
          <div className="newsletter-row">
            <div className="newsletter-col">
              <label className="newsletter-label">Graduation Year</label>
              <input
                className="newsletter-input"
                type="number"
                name="gradYear"
                placeholder="Year"
                min="2015"
                max="2035"
                value={formData.gradYear}
                onChange={handleChange}
                required
              />
            </div>
            <div className="newsletter-col">
              <label className="newsletter-label">Role Type</label>
              <select
                className="newsletter-input custom-dropdown"
                name="roleType"
                value={formData.roleType}
                onChange={handleChange}
                required
                style={{
                  backgroundImage: `url(${dropdownIcon})`,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "right 1rem center",
                  backgroundSize: "18px",
                  paddingRight: "2.5rem",
                }}
              >
                <option value="">Select one</option>
                <option value="Internship">Internship</option>
                <option value="Full-Time Job">Full-Time Job</option>
              </select>
            </div>
          </div>

          <button
            type="submit"
            className="newsletter-button"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Submitting..." : "Subscribe"}
          </button>
        </form>

        <p className="newsletter-footer">
          We respect your privacy. You can unsubscribe anytime.
        </p>
      </div>
    </div>
  );
};

export default Newsletter;
